window.html5QrCode = null;
window.qrCodeScanCallbacks = {};

window.openQrCodeScanModal = function(inputFieldId) {
    var modal = $('#qrCodeScanModal');
    modal.find('.modal-body').html('<div id="qrCodeReader_' + inputFieldId + '" style="width:100%;max-width:600px;margin:0 auto;"></div>');
    modal.find('.modal-footer').html(
        '<button type="button" class="btn btn-primary" data-dismiss="modal"><i class="fa fa-times"></i> Schließen</button>'
    );
    modal.modal('show');

    modal.on('hidden.bs.modal', function (e) {
            modal.find('.modal-body').html('');
            modal.find('.modal-footer').html('');
            window.qrStopScanning();
    });

    window.setTimeout(function() {
            window.qrStartScanning('qrCodeReader_' + inputFieldId, inputFieldId);
    }, 500);
};

window.qrStartScanning = function(readerId, inputFieldId) {
    Html5Qrcode.getCameras().then(devices => {
            if (devices && devices.length) {
                let  cameraId = devices.length > 1 ? devices[1].id : devices[0].id;
                window.html5QrCode = new Html5Qrcode(readerId);

                window.html5QrCode.start(
                    cameraId,
                    {
                        fps: 10,
                        qrbox: 250
                    },
                    qrCodeMessage => {
                        /*console.log('QR Code detected');*/
                        document.getElementById(inputFieldId).value = qrCodeMessage;
                        window.qrStopScanning(function() {
                                $('#qrCodeScanModal').modal('hide');
                        });
                        if (typeof window.qrCodeScanCallbacks[inputFieldId] === 'function') {
                            window.qrCodeScanCallbacks[inputFieldId]();
                        }
                    },
                    errorMessage => {
                        /*console.log('QR Code no longer in front of camera.');*/
                    }
                )
                .catch(err => {
                    console.log('Unable to start scanning:');
                    console.log(err);
                    $('#qrCodeScanModal').find('.modal-body').html('<div class="text-danger"><strong>Unable to start scanning!</strong><br />' + err + '</div>');
                });
            }
    }).catch(err => {
        console.log('error');
        console.log(err);
        $('#qrCodeScanModal').find('.modal-body').html('<div class="text-danger"><strong>Error!</strong><br />' + err + '</div>');
    });
};

window.qrStopScanning = function(cb) {
    if (window.html5QrCode && window.html5QrCode.isScanning) {
        window.html5QrCode.stop().then(ignore => {
            /*console.log("QR Code scanning stopped.");*/
        }).catch(err => {
            /*console.log("Unable to stop scanning.");*/
        });
    }

    if (typeof cb === 'function') {
        cb();
    }
};
